import { getStore, setStore, removeStore, clearStore } from '@/units/store'
import { defaultTenantId } from '@/units/config'
import appApi from '@/api/app';
const app = {
  state: {
    appInfo: getStore({ name: 'appInfo' }) || '',
    tenant_id: getStore({ name: 'tenant_id' }) || '',
    chatInfo: getStore({ name: 'chatInfo' }) || {},
  },
  actions: {
    /*获取APP信息*/
    /** 固定租户，不再请求 /api/common/getTenantId 按域名解析 */
    GetTenantId({ commit }) {
      commit('SET_TENANT_ID', defaultTenantId)
    },
    /*获取APP信息*/
    async GetAppInfo({ commit, dispatch }) {
      const {data} = await appApi.init({ templateId: '', tenant_id: getStore({ name: 'tenant_id' }) || '' });
      commit('SET_APP_INFO', { app: data.app, chat: data.chat })
    }
  },
  mutations: {
    SET_APP_INFO: (state, { app, chat }) => {
      state.appInfo = app
      setStore({ name: 'appInfo', content: app })
      state.chatInfo = chat || {}
      setStore({ name: 'chatInfo', content: state.chatInfo })
    },
    SET_TENANT_ID: (state, tenant_id) => {
      state.tenant_id = tenant_id;
      setStore({ name: 'tenant_id', content: tenant_id })
    },
  }
}
export default app;
